import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d31f119a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "orderList" }
const _hoisted_2 = { class: "orderTitle" }
const _hoisted_3 = { class: "orderContent" }
const _hoisted_4 = { class: "orderInfoWrapper" }
const _hoisted_5 = { class: "infoName" }
const _hoisted_6 = { class: "infoStatus" }
const _hoisted_7 = { class: "orderInfoWrapper" }
const _hoisted_8 = { class: "infoWrapper" }
const _hoisted_9 = { class: "money" }
const _hoisted_10 = { class: "timer" }

import { ref } from 'vue'
import { getOrderList } from '@/api/index'
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'orderList',
  setup(__props) {

const list: any = ref([])
const loading = ref(false)
const finished = ref(false)
const route = useRoute()

const goKf = () => {
  window.location.href = sessionStorage.getItem('kfUrl') as string; //'https://work.weixin.qq.com/kfid/kfce4ad33084a66a45d?enc_scene=ENC7FG6s6ataZAgJpw6cnJYzKZaMri7LGFqxmtyAG2ZgvzL'
}

const _getOrderList = () => {
  getOrderList({
    iccid: route.params.iccid
  }).then((res: any) => {
    finished.value = true
    loading.value = true
    list.value = res.result
  })
}

const onLoad = () => {
  if (loading.value || finished.value)  return
  console.log('onLoading')
  loading.value = true
  _getOrderList()
  // setTimeout(() => {
  //   for (let i = 0; i < 20; i++) {
  //     list.value.push({
  //       title: '订单' + new Date().getTime()
  //     })
  //   }
  //   loading.value = false
  //   if (list.value.length >= 40) {
  //     finished.value = true
  //     console.log('finished')
  //   }
  // }, 1000)
}

return (_ctx: any,_cache: any) => {
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_list, {
      modelValue: loading.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
      finished: finished.value,
      "finished-text": "没有更多了",
      onLoad: onLoad,
      offset: 10
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
          return (_openBlock(), _createBlock(_component_van_cell, {
            key: index,
            class: "orderItem"
          }, {
            title: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, "订单编号：" + _toDisplayString(item.orderNo), 1),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(item.packageName), 1),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(item.useStatus), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, "实付金额：￥" + _toDisplayString(item.realAmount || 0), 1),
                    _createElementVNode("div", _hoisted_10, "支付时间：" + _toDisplayString(item.payTime || '--'), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "btn",
                    onClick: goKf
                  }, "订单咨询")
                ])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "finished"])
  ]))
}
}

})